<template>
	<div class="wrapper">
		<div class="my-index">
			<img :src="url"></img>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'shareuserqrcode',
		data() {
			return {
				url: null,
			};
		},
		mounted() {
			this.url = this.$route.params.url;
			console.log(this.url);
		},
	}
</script>

<style scoped lang="scss">
	.my-index{
		width: 100%;
		height: 100%;
		overflow: hidden;
		position: fixed;
		top: 0;
		left: 0;
	}
	.my-index img{
		width: 100%;
		height: 100%;
	}
</style>
